import { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ROUTE_PATHS } from 'routes';
import { useDispatch } from 'react-redux';
import { color, theme } from 'constants/styled-theme';
import { LoginButton } from 'components/login-button';
import { changeTab } from '../active-auctions/actions';
import Tab from './tab';

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  height: 50px;
  overflow: auto;
  z-index: 10;
  background: ${color('backgroundMenuColor')};
  width: 100%;
`;
const LoginContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;
const Tabs = styled.div`
  display: flex;
  background: ${color('backgroundMenuColor')};
  justify-content: center;
  align-items: center;
  top: 0;
  z-index: 100;
  overflow: auto;
  @media (max-width: ${p => p.theme.mobile}) {
    justify-content: flex-start;
    width: 100%;
  }
`;

const AdminTabBar = ({ onMouseLeave }) => {
  const dispatch = useDispatch();
  const isCatalog = CONFIG.AUCTION_TYPE === 'collection';
  const tabsRef = useRef(null);
  const isMobile = window.matchMedia(`(max-width:${theme.mobile})`).matches;
  const scrollToRef = ref => {
    dispatch(changeTab());
    if (isMobile) {
      tabsRef.current.scrollTo({
        top: 0,
        left: ref.current.offsetLeft - 50,
        behavior: 'smooth'
      });
    }
  };

  return (
    <Header onMouseLeave={onMouseLeave}>
      <Tabs ref={tabsRef}>
        <Tab onClick={e => scrollToRef(e)} to={ROUTE_PATHS.CLOSE_AUCTIONS}>
          {isCatalog ? 'Closed Collections' : 'Closed Auctions'}
        </Tab>
        <Tab onClick={e => scrollToRef(e)} to={ROUTE_PATHS.MY_AUCTIONS}>
          My Auctions
        </Tab>
        <Tab onClick={e => scrollToRef(e)} to={ROUTE_PATHS.ACCOUNTS}>
          Accounts
        </Tab>
        {isMobile && (
          <LoginContainer>
            <LoginButton />
          </LoginContainer>
        )}
      </Tabs>
    </Header>
  );
};
export default AdminTabBar;

AdminTabBar.propTypes = {
  onMouseLeave: PropTypes.func
};
